import Permissions from '@/security/permissions';
import PermissionChecker from '@/modules/iam/permission-checker';

export class PrescriptionPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.prescriptionRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.prescriptionImport,
    );
    this.prescriptionAutocomplete = permissionChecker.match(
      Permissions.values.prescriptionAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.prescriptionCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.prescriptionEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.prescriptionDestroy,
    );
  }
}
